import clsx from 'clsx';
import React from 'react';

import Button, { ButtonProps } from '@components/Button';

export type SettingsSubmenuNavItemProps = ButtonProps;

const SettingsSubmenuNavItem = ({ className, ...rest }: ButtonProps) => (
  <li>
    <Button
      className={clsx(className, 'block font-suisse-screen text-overline-md text-white')}
      {...rest}
    />
  </li>
);

export default SettingsSubmenuNavItem;
